import theme from './theme';

// These are Groups for testing purposes
const GROUP_IDS = {
  local: '5c35323bfd036500224fd199',
  dev: '5c35323bfd036500224fd199',
  staging: '5c57744cf5c77800255e35ba',
  demo: '5d3b511ec6ace9002c6d5dd6', // Volunteer Now
  production: '5b693ea44c17fb0046033c5f',
  devAu: '5c35323bfd036500224fd199',
  stagingAu: '5c57744cf5c77800255e35ba',
  demoAu: '5d3b511ec6ace9002c6d5dd6', // Volunteer Now
  productionAu: '5b693ea44c17fb0046033c5f',
  productionEu: '5d3a4f0d93bf65002a05de1a',
  productionUk: '5d3a4f0d93bf65002a05de1a',
  datAu: '620b16f1de3f761e23313f31',
};

// VRCId is required for partnership requests
export default {
  default: {
    VRCId: GROUP_IDS[process.env.REACT_APP_ENV],
    name: 'Default Volunteer Center',
    contact: {
      phone: '+61 434 111 222',
      email: 'jane.doe@example.com',
    },
    primary: '#5485ed',
    primaryForeground: 'white',
    secondary: '#404042',
    secondaryForeground: 'white',
    loginPromoText:
      'Looking for volunteers? Use the form below to post your opportunities and let Be Collective help find the right match.  Be Collective provides the opportunity for any organisation of any size to access our social infrastructure, enabling them to promote, share and manage their opportunities and volunteers.', // a space to remove the loginPromoText (no default)
    loginText: '',
    loginButtonText: 'Login',
    registerPromoText:
      'Looking for volunteers? Use the form below to post your opportunities and let Be Collective help find the right match.  Be Collective provides the opportunity for any organisation of any size to access our social infrastructure, enabling them to promote, share and manage their opportunities and volunteers.',
    registerText: '',
    registerButtonText: '',
    ...theme,
    loginTitle: 'List your volunteering opportunities',
    registerTitle: 'List your volunteering opportunities',
    registerSubmitButtonText: 'Next' // Text of the submit button of the register form
  },
};
